import type { Task } from '../api/tasks.js';
import { TaskRow } from './TaskRow.js';
import { EmptyState } from './EmptyState.js';

/** Trois lignes en attente (`.squelette` du kit), à la hauteur d'une ligne de liste. */
export function ListSkeleton(): React.ReactElement {
  return (
    <div className="liste liste-aeree" aria-busy="true">
      {[0, 1, 2].map((i) => (
        <div key={i} className="squelette h-11" />
      ))}
    </div>
  );
}

export function TaskList({
  tasks,
  emptyMessage,
  loading,
  hideProject = false,
  showSubtitle = false,
}: {
  tasks: Task[];
  emptyMessage: string;
  loading: boolean;
  hideProject?: boolean;
  showSubtitle?: boolean;
}): React.ReactElement {
  if (loading) return <ListSkeleton />;
  if (tasks.length === 0) return <EmptyState>{emptyMessage}</EmptyState>;
  return (
    <div className="liste">
      {tasks.map((t) => (
        <TaskRow key={t.taskId} task={t} hideProject={hideProject} showSubtitle={showSubtitle} />
      ))}
    </div>
  );
}
